export default __webpack_public_path__ + "locales/hy-AM/ResetApplicationDialog.json?hash=95c2d2dcfbe675674772c11ea98c4ac2";